export enum CalculatorType {
    ConsumerTransaction, // Consumententransactie
    TradeTransaction, // Handelstransactie
    ContractTransaction // Contractueletransactie
}
